import * as React from 'react';

import { PageTitleBar } from 'components';

const AttributeHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { AttributeHeader };
